import { render, staticRenderFns } from "./editRoleIndex.vue?vue&type=template&id=73bd080a&"
import script from "./editRoleIndex.vue?vue&type=script&lang=js&"
export * from "./editRoleIndex.vue?vue&type=script&lang=js&"
import style0 from "./editRoleIndex.vue?vue&type=style&index=0&id=73bd080a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports